var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"backBtn"}},[_c('div',{on:{"click":_vm.back}},[_vm._v("返回")])])
}
var staticRenderFns = []

export { render, staticRenderFns }